import { render, staticRenderFns } from "./SuperReviewsDashboard.vue?vue&type=template&id=a7c23238&scoped=true"
import script from "./SuperReviewsDashboard.vue?vue&type=script&lang=js"
export * from "./SuperReviewsDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c23238",
  null
  
)

export default component.exports